import type { ThemeConfig } from 'antd';

// ── WorkWav brand palette ────────────────────────────────────────────────────
const SKY        = '#56B0FF';   // primary brand colour
const SKY_DARK   = '#2196F3';   // slightly darker sky for hover/active states
const SKY_LIGHT  = '#e8f4ff';   // very light sky tint for backgrounds

export const themeConfig: ThemeConfig = {
  token: {
    // ── Brand ────────────────────────────────────────────────────────
    colorPrimary: SKY,
    colorLink:    SKY,

    // ── Text — clearly readable hierarchy ────────────────────────────
    colorText:          '#0f172a',   // near-black for body text
    colorTextSecondary: '#334155',   // dark slate for secondary labels
    colorTextTertiary:  '#64748b',   // medium slate for hints / timestamps
    colorTextQuaternary:'#94a3b8',   // light slate for placeholders

    // ── Backgrounds ───────────────────────────────────────────────────
    colorBgBase:      '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgLayout:    '#f1f5f9',     // slightly more distinct page background
    colorBgElevated:  '#ffffff',

    // ── Borders — slightly more visible ──────────────────────────────
    colorBorder:          '#cbd5e1', // 1 step darker than default
    colorBorderSecondary: '#e2e8f0',

    // ── Feedback colours ──────────────────────────────────────────────
    colorSuccess:      '#16a34a',
    colorWarning:      '#ca8a04',
    colorWarningBg:    '#fefce8',
    colorWarningBorder:'#fde047',
    colorError:        '#dc2626',
    colorInfo:         SKY_DARK,

    // ── Typography ────────────────────────────────────────────────────
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontSize:       14,
    fontWeightStrong: 700,

    // ── Shape ─────────────────────────────────────────────────────────
    borderRadius:   8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,

    // ── Shadow ───────────────────────────────────────────────────────
    boxShadow:         '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)',
    boxShadowSecondary:'0 4px 16px rgba(0,0,0,0.10)',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg:  '#ffffff',
      bodyBg:   '#f1f5f9',
    },
    Menu: {
      itemBg:           '#ffffff',
      itemSelectedBg:   SKY_LIGHT,
      itemSelectedColor: SKY,
      itemHoverBg:      SKY_LIGHT,
      itemHoverColor:   SKY,
      itemColor:        '#334155',
      activeBarHeight:  3,
    },
    Button: {
      primaryColor: '#ffffff',
      fontWeight:   600,
    },
    Card: {
      colorBorderSecondary: '#e2e8f0',
      boxShadowTertiary:    '0 1px 4px rgba(0,0,0,0.07)',
    },
    Table: {
      headerBg:          '#f8fafc',
      headerColor:       '#1e293b',
      rowHoverBg:        SKY_LIGHT,
      borderColor:       '#e2e8f0',
      headerSplitColor:  '#e2e8f0',
    },
    Input: {
      colorBorder:         '#cbd5e1',
      colorTextPlaceholder:'#94a3b8',
      activeBorderColor:   SKY,
    },
    Select: {
      colorBorder:          '#cbd5e1',
      colorTextPlaceholder: '#94a3b8',
      optionSelectedBg:     SKY_LIGHT,
      optionSelectedColor:  SKY,
      optionActiveBg:       SKY_LIGHT,
    },
    Tag: {
      defaultColor: '#334155',
      defaultBg:    '#f1f5f9',
    },
    Typography: {
      colorTextHeading: '#0f172a',
    },
    Statistic: {
      colorTextHeading: '#334155',
    },
  },
};
